import { render } from "./RegionAlmaty.vue?vue&type=template&id=59421557&ts=true"
import script from "./RegionAlmaty.vue?vue&type=script&lang=ts"
export * from "./RegionAlmaty.vue?vue&type=script&lang=ts"

import "./RegionAlmaty.vue?vue&type=style&index=0&id=59421557&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__